import { render, staticRenderFns } from "./CreateAccountModal.vue?vue&type=template&id=6bd94b0f&scoped=true"
import script from "./CreateAccountModal.vue?vue&type=script&lang=js"
export * from "./CreateAccountModal.vue?vue&type=script&lang=js"
import style0 from "./CreateAccountModal.vue?vue&type=style&index=0&id=6bd94b0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd94b0f",
  null
  
)

export default component.exports